import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c957b11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-info-confirm-next" }
const _hoisted_2 = { class: "pay-info-confirm-next__content" }
const _hoisted_3 = { class: "pay-info-confirm-next__content__item" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "（预计）", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  style: {"padding-bottom":"0","padding-right":"0"},
  class: "xrk-dialog__footer"
}

import { ref } from 'vue';
import { maskPhone } from '@/utils/formatter';
import { getVerifyCodeApi, paySubmit } from '../data-source/apis';
import { formatter } from '@/utils';
import { ORDER_PRICE_TYPE } from '../constants';
import {
  BaseButton,
  BaseInput,
  BasePagination,
  XrkMessage,
  createDialog
} from 'xrk-components';
import emitter from '../utils/event-bus';
import router from '@/router';
import { statisticsConfirmList, operatorInfo } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-info-confirm-next',
  props: {
    done: { default: () => ({}) },
    payInfo: { default: null }
  },
  setup(__props: any) {

const props = __props;

const getTaxType = () => {
  // 获取订单来自劳务还是经营taxType
  return { taxType: router.currentRoute.value.meta.taxType };
};

const currentPage = ref(1);
const pageSize = ref(1);

const verifyCode = ref('');
const countdown = ref<number>(0);
const codeMsg = ref('获取验证码');

const phoneNumber = ref('');

const getPhoneNumber = async () => {
  const { data } = await operatorInfo({ t: Date.now() });
  phoneNumber.value = data.phone;
};
getPhoneNumber();
const getVerifyCode = async () => {
  if (countdown.value === 0) {
    await getVerifyCodeApi({
      phone: phoneNumber.value
    });
    countdown.value = 60;

    const intervalId = setInterval(() => {
      if (countdown.value === 1) codeMsg.value = '重新获取验证码';

      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
  }
};

const onPay = async () => {
  const isLine = props.payInfo.some(item => item.payType === 1);
  if (isLine) {
    // 线上支付发送验证码校验
    createDialog({
      title: '支付身份校验',
      showClose: true,
      confirmBtnConfig: {
        content: '确认'
      },
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>验证码将发送至您的手机：{maskPhone(phoneNumber.value)}</span>
            <div style="display: flex;margin-top: 20px">
              <BaseInput
                inputTextReplace
                inputTexts={['数字']}
                v-model={verifyCode.value}
                maxlength={6}
                placeholder="请输入验证码"
              />
              <BaseButton
                click={() => {
                  getVerifyCode();
                }}
                disabled={countdown.value > 0}
                type="primary"
                style="margin-left: 5px;width: 100px"
              >
                {countdown.value || codeMsg.value}
              </BaseButton>
            </div>
          </div>
        );
      },
      async beforeConfirm(done) {
        if (!verifyCode.value) {
          XrkMessage.error('请输入验证码');
          return Promise.reject();
        }
        await paySubmit({
          verifyCode: verifyCode.value,
          aspOrderIdList: props.payInfo.map(item => item.aspOrderId).flat()
        });

        XrkMessage.success('支付成功');
        emitter.emit('refresh-order-tabel', { data: true });
        props.done();
        done();
      }
    });
  } else {
    //线下支付不需要验证码
    await paySubmit({
      aspOrderIdList: props.payInfo.map(item => item.aspOrderId).flat()
    });
    XrkMessage.success('支付成功');
    emitter.emit('refresh-order-tabel', { data: true });
    props.done();
  }
};

const infoData = ref([]);

const infoPageData = ref();

const handleSizeChange = ({ currentPage }) => {
  infoPageData.value = infoData.value[currentPage - 1];
};
const getAsyncData = async () => {
  const { data } = await statisticsConfirmList({
    aspOrderIdList: props.payInfo.map(item => item.aspOrderId)
  });
  infoData.value = data;
  infoPageData.value = infoData.value[0];
};
getAsyncData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, "项目名称：" + _toDisplayString(infoPageData.value?.projectName), 1),
        _createElementVNode("div", null, "支付订单数量：" + _toDisplayString(infoPageData.value?.payOrderNum), 1),
        _createElementVNode("div", null, [
          _createTextVNode(" 支付总金额：" + _toDisplayString(_unref(formatter).fen2yuan(infoPageData.value?.orderPaymentTotalAmount, '元')) + " ", 1),
          (getTaxType().taxType === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "（预计）"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, "支付通道：" + _toDisplayString(infoPageData.value?.payPassagewayName), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoPageData.value?.statisticsConfirmDetailList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "pay-info-confirm-next__content__item"
        }, [
          _createElementVNode("div", null, "订单编号：" + _toDisplayString(item.orderNo), 1),
          _createElementVNode("div", null, " 订单类型：" + _toDisplayString(_unref(ORDER_PRICE_TYPE)[item.orderType]?.label || '-'), 1),
          (item.orderType === 1 && getTaxType().taxType === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 终端结算金额：" + _toDisplayString(_unref(formatter).fen2yuan(item.terminalSettlementAmount, '元')), 1))
            : _createCommentVNode("", true),
          (item.orderType === 1 && getTaxType().taxType === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" 扣除个税金额：" + _toDisplayString(_unref(formatter).fen2yuan(item.deductIndividualTaxAmount, '元')) + " ", 1),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createTextVNode(" 订单支付金额：" + _toDisplayString(_unref(formatter).fen2yuan(item.orderPaymentAmount, '元')) + " ", 1),
            (item.orderType === 1 && getTaxType().taxType === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " （预计） "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, "支付对象：" + _toDisplayString(item.paymentRecipientDescribe), 1)
        ]))
      }), 128))
    ]),
    _createVNode(_unref(BasePagination), {
      style: {"margin":"15px"},
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      layout: ['total', 'prev', 'pager', 'next', 'jumper'],
      total: infoData.value.length,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleSizeChange
    }, null, 8, ["current-page", "page-size", "total"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: props.done
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        disabled: !_ctx.payInfo.length,
        type: "primary",
        onClick: onPay
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 发起支付 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})